import React, { useCallback, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { IVideo } from '../../init';
import { TChannels } from '../../interfaces/channels';
import { TMessageListOrder } from '../../interfaces/params';
import { RootState } from '../../store';
import { getControlData } from '../../utils';
import { sanitizeProcessedVideo, toggleProcessedVideo } from '../app/appSlice';
import VideoItem from './videoItem';

interface IVideoListProps extends PropsFromRedux, React.AllHTMLAttributes<HTMLDivElement> {
	videos: IVideo[];
	totalCount: number;
	startNo: number;
	channels: TChannels;
	mlo: TMessageListOrder;
}
const VideoList = ({
	videos,
	channels,
	totalCount,
	startNo,
	mlo,
	processedVideo,
	toggleProcessedVideo,
	sanitizeProcessedVideo,
	processedMarkEnabled,
}: IVideoListProps) => {
	const onListClick = useCallback(
		async (event: React.MouseEvent<HTMLDivElement>) => {
			const youtubeId = getControlData(event.target, '.videos__processed-mark', 'youtubeId') as string;
			if (!youtubeId) return;

			event.preventDefault();
			event.stopPropagation();
			toggleProcessedVideo(youtubeId);
		},
		[toggleProcessedVideo]
	);

	useEffect(() => {
		sanitizeProcessedVideo();
		// Проводимо очищення промаркованих відео 1 раз в час
		const tm = setInterval(sanitizeProcessedVideo, 1 * 60 * 60 * 1000);
		return () => {
			clearInterval(tm);
		};
	}, [sanitizeProcessedVideo]);

	if (!channels) return <></>;
	return (
		<div className="videos__list mb-3 gap-4" onClick={onListClick}>
			{videos.map((video, index) => (
				<VideoItem
					key={video.YOUTUBE_ID}
					video={video}
					channel={channels[video.CHANNEL_ID]}
					no={mlo === 'D' ? startNo + index + 1 : totalCount - (startNo + index)}
					processedTs={processedVideo[video.YOUTUBE_ID]}
					processedMarkEnabled={processedMarkEnabled}
				/>
			))}
		</div>
	);
};

const mapState = (state: RootState) => ({
	processedVideo: state.app.processedVideo,
	processedMarkEnabled: state.app.isProcessedMarksEnabled,
});

const mapDispatch = { toggleProcessedVideo, sanitizeProcessedVideo };

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(VideoList);
